import React from 'react';
import { createPortal } from 'react-dom';
import DOMPurify from 'dompurify';
import '../styles/course-tips-modal.css';

interface CourseTipsModalProps {
    isOpen: boolean;
    onClose: () => void;
    onLaunchCourse: () => void;
    courseTitle?: string;
    modalHeading?: string;
    modalContent?: string;
    modalButtonLabel?: string;
}

export default function CourseTipsModal({
    isOpen,
    onClose,
    onLaunchCourse,
    courseTitle,
    modalHeading,
    modalContent,
    modalButtonLabel
}: CourseTipsModalProps) {
    if (!isOpen) return null;

    const handleLaunchCourse = () => {
        onLaunchCourse();
        onClose();
    };

    // Use dynamic content if provided, otherwise fall back to default
    const heading = modalHeading || "Tips Before You Get Started";
    const content = modalContent || "Congratulations, you're taking the next step in growing your skills! Here are a few quick tips to help you stay on track and share your progress:";
    const buttonLabel = modalButtonLabel || "Launch course";

    return createPortal(
        <div className="modal-overlay">
            <div className="course-tips-modal-content">
                <button className="modal-close-btn" onClick={onClose}>
                    ×
                </button>

                <div className="course-tips-body">
                    <h2 className="course-tips-title">{heading}</h2>

                    <div className="course-tips-intro" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(content) }} />

                    {!modalContent && (
                        <div className="course-tips-section">
                            <h3 className="course-tips-section-title">How to Manage This Course</h3>

                            <div className="course-tips-list">
                                <div className="course-tip-item">
                                    <strong>Game Plan:</strong> All tasks and resources for this course live in your Game Plan. Use it as your roadmap to stay organized and monitor your progress.
                                </div>

                                <div className="course-tip-item">
                                    <strong>Digital Badge:</strong> Once you complete the course, you'll earn a digital badge that you can download and share on your social media channels.
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                <div className="course-tips-footer">
                    <button className="launch-course-btn" onClick={handleLaunchCourse}>
                        {buttonLabel}
                    </button>
                </div>
            </div>
        </div>,
        document.body
    );
}
